
import { LabelObject } from 'globals/store/events.data';
import { MatDialog } from '@angular/material/dialog';
import { LabelMakerData, LabelMakerDialogComponent, LabelUpdateFunction } from '../components/label-marker/label-maker.dialog.component';
import { titleCase } from './helpers';
import { LabelType } from '../services/ui.service';

export const openLabelMakerDialog = (dialog: MatDialog, data: LabelMakerData) => dialog.open(LabelMakerDialogComponent, {
  minWidth: '300px',
  backdropClass: 'backdrop',
  panelClass: ['label-panel', 'centered'],
  maxHeight: '99vh',
  data
})


export const removeLabelsFromMany = <E extends { labels?: string[], id?: string }>(labelUpdateFunction: LabelUpdateFunction, fullLabelsTemplate: LabelObject, dialog: MatDialog, type: LabelType, entities: E[], event) => {
  const esWithLabels = entities.filter(e => e.labels && e.labels.length)
  const labelTemplate = Object.values(fullLabelsTemplate).filter(label => esWithLabels.some(e => e.labels.includes(label.id)) || esWithLabels.some(e => e.labels.includes(label.id)))
  const data: LabelMakerData = {
    labels: labelTemplate.map(l => l.id),
    type,
    uneditable: true,
    startTicked: true,
    title: `Remove ${titleCase(type)} Labels`,
    position: { top: event.y + 30, left: event.x - 300 },
    labelUpdateFunction,
    labelTemplate,
  }
  openLabelMakerDialog(dialog, data)
}

export const addLabelsToMany = <E extends { labels?: string[], id?: string }>(labelUpdateFunction: LabelUpdateFunction, fullLabelsTemplate: LabelObject, dialog: MatDialog, type: LabelType, entities: E[], event) => {
  const someHasNoLabels = entities.some(e => !e.labels)
  const labelTemplate = (Object.values(fullLabelsTemplate)).filter(label => someHasNoLabels || entities.some(e => !e.labels.includes(label.id)))
  const data: LabelMakerData = {
    labels: [],
    type,
    position: { top: event.y + 30, left: event.x - 300 },
    labelUpdateFunction,
    labelTemplate,
    title: `Add ${titleCase(type)} Labels`,
  }
  openLabelMakerDialog(dialog, data)
}


